import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-success_green",
  "use": "icon-success_green-usage",
  "viewBox": "0 0 1230 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1230 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-success_green\"><path d=\"M1068.3392 13.5168L473.088 608.768 160.4608 296.2432 0 456.704l472.9856 473.088 755.712-755.8144L1068.4416 13.6192z\" fill=\"#30C691\" p-id=\"5130\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol